/**
 * Brand tokens. Surface and text colors come from Telegram theme variables
 * (see Layout.tsx → bindThemeParamsCssVars). The brand gradient is custom and
 * applied on top: MainButton, hero animations, accents, bottom-nav active tab.
 */
export const brand = {
  from: '#FF6B9D',
  to: '#C44569',
  solid: '#E5407A',
  gradient: 'linear-gradient(135deg, #FF6B9D 0%, #C44569 100%)',
  glow: '0 8px 22px -6px rgba(229, 64, 122, 0.55)',
} as const;

export const gold = {
  from: '#F4B23E',
  to: '#E89627',
  solid: '#E89627',
  gradient: 'linear-gradient(135deg, #F4B23E 0%, #E89627 100%)',
} as const;

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  pill: 9999,
} as const;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

export const fontFamily =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif';

export const shadow = {
  sm: '0 2px 8px rgba(0, 0, 0, 0.04)',
  md: '0 4px 12px rgba(0, 0, 0, 0.08)',
  lg: '0 8px 22px -6px rgba(0, 0, 0, 0.15)',
  brandGlow: brand.glow,
} as const;

/**
 * Telegram theme CSS variable shortcuts. Always use these instead of
 * hardcoded #fff/#000 to support light/dark and any user theme.
 */
export const tg = {
  bg: 'var(--tgui--bg_color)',
  bg2: 'var(--tgui--secondary_bg_color)',
  bg3: 'var(--tgui--section_bg_color, var(--tgui--secondary_bg_color))',
  text: 'var(--tgui--text_color)',
  textHint: 'var(--tgui--hint_color)',
  textLink: 'var(--tgui--link_color)',
  destructive: 'var(--tgui--destructive_text_color)',
  divider: 'var(--tgui--section_separator_color, rgba(0,0,0,0.06))',
} as const;
